import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { EmbeddedCheckout } from "tf-checkout-react"

import { CHECKOUT, checkoutCopy } from "../../config/checkout"
import { useCheckoutLocale } from "../../i18n/useCheckoutLocale"
import { navigateAfterCheckout } from "../../utils/checkout-completion"
import { Loader } from "../loader"

const CheckoutKit = ({ eventId, initialPromoCode, initialView, onViewChange }) => {
  // Cart/auth continuity stays SDK-owned; this wrapper supplies brand and routing.
  const { t } = useTranslation(["checkout", "common"])
  const locale = useCheckoutLocale()
  const [hydrated, setHydrated] = useState(false)
  useEffect(() => setHydrated(true), [])

  if (!hydrated) {
    // Keep route and SDK loading feedback visually identical.
    return <Loader />
  }

  // The opt-in label and privacy policy are the only strings this host owns;
  // the rest of the checkout's copy ships with tf-checkout-react and follows
  // the `locale` below. Without it the SDK falls back to en-GB, which left the
  // whole billing and payment step in English inside a Spanish page.
  const copy = checkoutCopy(t)

  return (
    <EmbeddedCheckout
      eventId={String(eventId)}
      initialPromoCode={initialPromoCode}
      onViewChange={onViewChange}
      confirmationMode="redirect"
      initialView={initialView}
      onComplete={navigateAfterCheckout}
      theme={CHECKOUT.theme}
      locale={locale}
      requireEmailConfirmation={CHECKOUT.requireEmailConfirmation}
      collectTicketHolders={CHECKOUT.collectTicketHolders}
      collectHolderContact={CHECKOUT.collectHolderContact}
      skipBillingWhenProfileComplete={CHECKOUT.skipBillingWhenProfileComplete}
      brandOptInLabel={copy.brandOptInLabel}
      privacyPolicy={copy.privacyPolicy}
      auth={{ logoUrl: CHECKOUT.logo }}
    />
  )
}

export default CheckoutKit
